<div class="role-view">
    <ng-container [dynamic]="view()"></ng-container>
</div>
